import React from 'react';
import { Typography, Box } from '@mui/material';

const AppDescription = () => {
    return (
        <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                テクスチャ画像最適化アプリ
            </Typography>
            
            <Typography variant="h6" component="h2">
                PoTサイズへの最適化に対応し、GPU処理効率を向上させます。
            </Typography>
        </Box>
    );
};

export default AppDescription;
